(() => {
  if (window.fareverBuyNowInitialized) return;
  window.fareverBuyNowInitialized = true;

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-farever-buy-now]');
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    event.preventDefault();

    const form = button.closest('product-form')?.querySelector('form');
    if (!form) return;

    const formData = new FormData(form);
    const variantId = formData.get('id');
    const requestedQuantity = Number.parseInt(formData.get('quantity') || '1', 10);
    const quantity = Number.isFinite(requestedQuantity) && requestedQuantity > 0 ? requestedQuantity : 1;
    const cartUrl = (button.dataset.cartUrl || '/cart').replace(/\/$/, '');

    if (!variantId) return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    button.querySelector('.loading__spinner')?.classList.remove('hidden');

    window.location.assign(`${cartUrl}/${encodeURIComponent(variantId)}:${quantity}`);
  });
})();


